'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CwLog = require('../../services/CwLog');

var _CwLog2 = _interopRequireDefault(_CwLog);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwRouter = function (_Component) {
  (0, _inherits3.default)(CwRouter, _Component);

  function CwRouter() {
    (0, _classCallCheck3.default)(this, CwRouter);
    return (0, _possibleConstructorReturn3.default)(this, (CwRouter.__proto__ || (0, _getPrototypeOf2.default)(CwRouter)).apply(this, arguments));
  }

  (0, _createClass3.default)(CwRouter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          selectedId = _props.selectedId,
          children = _props.children;


      if (_react2.default.Children.count(children) > 1) {
        for (var i = 0; i < children.length; i++) {
          if (children[i].props.id === selectedId) {
            return children[i];
          }
        }

        _CwLog2.default.error('CwRouter - no matching id found for selectedId: ' + selectedId);
        return null;
      } else {
        return children;
      }
    }
  }]);
  return CwRouter;
}(_react.Component);

exports.default = CwRouter;


CwRouter.propTypes = {
  selectedId: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.element), //CwRoute
  _propTypes2.default.element //CwRoute
  ]).isRequired
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/cwrouter/CwRouter.js
// module id = 325
// module chunks = 10